import axios from 'axios'
import type { Document, DocumentLink } from 'BrokerTsLib/src/dtos'
import { Product } from 'BrokerTsLib/src/enums'
import type { GenericQueryOptions } from 'BrokerTsLib/src/hooks'
import { longStaleTime } from 'BrokerTsLib/src/hooks'
import { useQuery } from 'react-query'

import { baseUrl } from '.'
import { useApp } from './useApp'

const documentVehicleUrl = import.meta.env.VITE_DOCUMENT_VEHICLE_API
const documentTravelUrl = import.meta.env.VITE_DOCUMENT_TRAVEL_API
const documentPropertyUrl = import.meta.env.VITE_DOCUMENT_PROPERTY_API
const documentLiabilityUrl = import.meta.env.VITE_DOCUMENT_LIABILITY_API

export const useUrl = () => {
  const { product } = useApp()

  let url: string | undefined = ''

  switch (product) {
    case Product.TravelInsurance: url = documentTravelUrl; break
    case Product.PropertyInsurance: url = documentPropertyUrl; break
    case Product.LiabilityInsurance: url = documentLiabilityUrl; break
    default: url = documentVehicleUrl; break
  }

  return `${baseUrl}/${url}`
}


export const useGetAllDocuments = (paramsId: string, insurerOfferId?: number | null, options?: GenericQueryOptions<DocumentLink[]>) => {
  const url = useUrl()
  return useQuery({
    queryKey: ['GetAllDocuments', paramsId, insurerOfferId],
    queryFn: () => axios.get<DocumentLink[]>(`${url}/GetAllDocuments`, { params: { paramsId, insurerOfferId } }),
    refetchOnWindowFocus: false,
    retry: false,
    ...options
  })
}

export const useGetOfferDocuments = (offerId: number, options?: GenericQueryOptions<Document[]>) => {
  const url = useUrl()
  return useQuery({
    queryKey: ['GetOfferDocuments', offerId],
    queryFn: () => axios.get<Document[]>(`${url}/GetOfferDocuments?offerId=${offerId}`),
    refetchOnWindowFocus: false,
    retry: false,
    ...options
  })
}

export const useGetBrandLogo = (categoryId?: number | null, brand?: string | null, options?: GenericQueryOptions<string>) => {
  const url = useUrl()

  return useQuery({
    queryKey: ['GetBrandLogo', categoryId, brand],
    queryFn: () => axios.get<string>(`${url}/GetBrandLogoBase64?categoryId=${categoryId}&brand=${brand}`),
    staleTime: longStaleTime,
    refetchOnMount: false,
    retry: false,
    ...options
  })
}


export type VehicleIdentificationLinkPropsDto = {
  paramsId?: string
  spz?: string | null
  vin?: string | null
  vehicleId?: string
}

export const getVehicleIdentificationLink = (data: VehicleIdentificationLinkPropsDto) => {
  const url = `${baseUrl}/${documentVehicleUrl}`

  let idParam = ''
  if (data.paramsId) idParam = `&id=${data.paramsId}`
  let vinParam = ''
  if (data.vin) vinParam = `&vin=${data.vin}`
  let spzParam = ''
  if (data.spz) spzParam = `&registrationMark=${data.spz}`

  return `${url}/GetIdentificatedVehiclePdf?vehicleId=${data.vehicleId}${vinParam}${spzParam}${idParam}`
}